import React from 'react';
import HistoryDownloadForm from '@di-shared/features/history/download/HistoryDownloadForm';

interface HistoryDownloadPageProps {
  vin: string;
}

export default function HistoryDownloadPage({vin}: HistoryDownloadPageProps) {
  return <HistoryDownloadForm vin={vin} />;
}
